import React from 'react'
import Header from '../../Modules/Header/Header'
import Contacts from './Contacts'

const PagesContact = () => {
  return (
    <div>
      <Header />
      <Contacts />
    </div>
  )
}

export default PagesContact
